<template>
    <Tag color-class="bg-purple-100 text-purple-700"></Tag>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'TagKarma',
});
</script>
